import React, { useState, useEffect } from 'react';
import { Card } from '@heroui/react';
import { Clock, Calendar } from 'lucide-react'; // Vérifiez l'installation de lucide-react pour accéder aux icônes
import { motion } from 'framer-motion';

const TimeDisplay = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    // Formatage des heures, minutes, secondes et de la date
    const hours = currentTime.getHours().toString().padStart(2, '0');
    const minutes = currentTime.getMinutes().toString().padStart(2, '0');
    const seconds = currentTime.getSeconds().toString().padStart(2, '0');
    const day = currentTime.getDate().toString().padStart(2, '0');
    const month = (currentTime.getMonth() + 1).toString().padStart(2, '0'); // Les mois commencent à 0
    const year = currentTime.getFullYear();

    return (
        <motion.div
            className="h-full w-full mx-auto flex flex-col items-center "
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Card shadow="sm" className="w-full p-4 bg-white rounded-lg h-full items-center justify-center dark:bg-zinc-900 ">
                <div className="flex flex-col items-center">
                    {/* Affichage de l'heure */}
                    <div className="flex items-center space-x-2">
                        <Clock className="w-8 h-8 text-primary" />
                        <h1 className="text-4xl font-bold text-gray-800 dark:text-gray-100">
                            {hours}:{minutes}:{seconds}
                        </h1>
                    </div>
                    {/* Affichage de la date */}
                    <div className="flex items-center space-x-2 mt-4">
                        <Calendar className="w-8 h-8 text-primary" />
                        <p className="text-xl text-gray-600">
                            {day}/{month}/{year}
                        </p>
                    </div>
                </div>
            </Card>
        </motion.div>
    );
};

export default TimeDisplay;
